import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import { useCallback } from 'react';
import { useDeviceType } from '~/context/common/DeviceContext';

const fastlyHostnameMap = new Map([
  ['carvanaassetsdev.blob.core.windows.net', 'assets.fastly.zagforward.com'],
  ['carvanablobdev.blob.core.windows.net', 'blob.fastly.zagforward.com'],
  ['carvanacdndev.blob.core.windows.net', 'cdnblob.fastly.zagforward.com'],
  ['carvanaassetstest.blob.core.windows.net', 'assets.fastly.carvanatech.com'],
  ['carvanablobtest.blob.core.windows.net', 'blob.fastly.carvanatech.com'],
  ['carvanacdntest.blob.core.windows.net', 'cdnblob.fastly.carvanatech.com'],
  ['carvanaassetsprod.blob.core.windows.net', 'assets.fastly.carvana.io'],
  ['carvanablobprod.blob.core.windows.net', 'blob.fastly.carvana.io'],
  ['carvanacdnprod.blob.core.windows.net', 'cdnblob.fastly.carvana.io'],
  [
    'cvnavexgatewaydev.blob.core.windows.net',
    'vexgateway.fastly.zagforward.com'
  ],
  [
    'cvnavexgatewaytest.blob.core.windows.net',
    'vexgateway.fastly.carvanatech.com'
  ],
  ['cvnavexgateway.blob.core.windows.net', 'vexgateway.fastly.carvana.io']
]);

type Options = {
  crop?: string;
};

// TODO: refactor to use `optimizeImage` utility function
export default function useOptimizeImage() {
  const { devicePixelRatio } = useDeviceType();

  return useCallback(
    (originalUrl: string, width: number, options?: Options) => {
      if (!originalUrl) return '';

      const url = new URL(originalUrl);
      const fastlyHostname = fastlyHostnameMap.get(url.hostname);
      if (fastlyHostname) {
        url.hostname = fastlyHostname;
      }
      if (options?.crop) url.searchParams.set('crop', options.crop);
      url.searchParams.set('dpr', String(devicePixelRatio));
      // optimize less on desktop since network speed tends to be better
      url.searchParams.set(
        'optimize',
        width > legacyBreakpoints.m ? 'low' : 'medium'
      );
      url.searchParams.set('width', String(width));

      return url.toString();
    },
    [devicePixelRatio]
  );
}
